module.exports = __webpack_public_path__ + "img/g.60b4d27f.jpeg";